import React from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const BudgetCalculationModal = ({ show, onHide, assignment, distributionInfo }) => {
  if (!assignment || !distributionInfo) {
    return null;
  }

  // Generar distribución día por día
  const generateDailyDistribution = () => {
    const startDate = new Date(assignment.dateFrom);
    const endDate = new Date(assignment.dateTo);
    const days = [];
    
    for (let d = new Date(startDate); d <= endDate; d.setDate(d.getDate() + 1)) {
      const currentDate = new Date(d);
      const dayOfWeek = currentDate.getDay(); // 0 = Domingo
      const isFirstDay = currentDate.getTime() === startDate.getTime();
      const isLastDay = currentDate.getTime() === endDate.getTime();
      
      let dayAmount;
      if (isFirstDay) {
        dayAmount = parseFloat(distributionInfo.firstDayAmount);
      } else if (isLastDay) {
        dayAmount = parseFloat(distributionInfo.lastDayAmount);
      } else {
        dayAmount = parseFloat(distributionInfo.dailyAmountAdjusted);
      }
      
      days.push({
        date: currentDate.toISOString().split('T')[0],
        formattedDate: currentDate.toLocaleDateString('es-ES'),
        dayOfWeek,
        amount: dayAmount,
        isFirstDay,
        isLastDay,
        isWeekend: dayOfWeek === 0 || dayOfWeek === 6
      });
    }
    
    return days;
  };

  const dailyDistribution = generateDailyDistribution();
  const totalCalculated = dailyDistribution.reduce((sum, day) => sum + day.amount, 0);

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon="calculator" className="me-2 text-primary" />
          Cálculo Detallado de Distribución
        </Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        <div className="mb-4">
          <h6 className="text-primary mb-3">Resumen de Distribución</h6>
          
          <div className="row g-3 mb-4">
            <div className="col-md-6">
              <div className="p-3 bg-light rounded">
                <strong>Información General</strong>
                <div className="mt-2 small">
                  <div>Cantidad de días Totales: <Badge bg="info">{distributionInfo.totalDays}</Badge></div>
                  <div>Monto x día: <Badge bg="success">${(assignment.amount / distributionInfo.totalDays).toFixed(2)}</Badge></div>
                  <div>Cantidad de Semanas: <Badge bg="warning">{distributionInfo.totalWeeks}</Badge></div>
                </div>
              </div>
            </div>
            
            <div className="col-md-6">
              <div className="p-3 bg-light rounded">
                <strong>Distribución Especial</strong>
                <div className="mt-2 small">
                  <div>Valor Primer día: <Badge bg="primary">${distributionInfo.firstDayAmount}</Badge></div>
                  <div>Prorrateo primer día: <Badge bg="secondary">${(parseFloat(distributionInfo.firstDayAmount) / parseFloat(distributionInfo.dailyAmountAdjusted)).toFixed(2)}</Badge></div>
                  <div>Valor Último día: <Badge bg="primary">${distributionInfo.lastDayAmount}</Badge></div>
                  <div>Prorrateo último día: <Badge bg="secondary">${(parseFloat(distributionInfo.lastDayAmount) / parseFloat(distributionInfo.dailyAmountAdjusted)).toFixed(2)}</Badge></div>
                </div>
              </div>
            </div>
          </div>

          <h6 className="text-success mb-3">Distribución Día por Día</h6>
          
          <div className="table-responsive" style={{ maxHeight: '300px', overflowY: 'auto' }}>
            <Table size="sm" striped>
              <thead className="bg-primary text-white">
                <tr>
                  <th>Fecha</th>
                  <th>Día</th>
                  <th>Valor</th>
                  <th>Tipo</th>
                </tr>
              </thead>
              <tbody>
                {dailyDistribution.map((day, index) => (
                  <tr key={index} className={day.isWeekend ? 'table-warning' : ''}>
                    <td>{day.formattedDate}</td>
                    <td>
                      {['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'][day.dayOfWeek]}
                    </td>
                    <td className="fw-bold text-success">
                      ${day.amount.toFixed(2)}
                    </td>
                    <td>
                      {day.isFirstDay && <Badge bg="primary" className="me-1">Primer</Badge>}
                      {day.isLastDay && <Badge bg="secondary" className="me-1">Último</Badge>}
                      {!day.isFirstDay && !day.isLastDay && <Badge bg="info">Normal</Badge>}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot className="bg-light">
                <tr>
                  <th colSpan="2">Total Calculado:</th>
                  <th className="text-success">${totalCalculated.toFixed(2)}</th>
                  <th>
                    {Math.abs(totalCalculated - assignment.amount) < 0.01 ? 
                      <Badge bg="success">✓ Correcto</Badge> : 
                      <Badge bg="warning">⚠ Diferencia</Badge>
                    }
                  </th>
                </tr>
              </tfoot>
            </Table>
          </div>

          <div className="mt-3 p-3 bg-info bg-opacity-10 rounded">
            <h6 className="text-info">Información Adicional</h6>
            <div className="small">
              <div>Valor Semana Inicial: <strong>${distributionInfo.weeklyAmountEstimate}</strong></div>
              <div>Valor Semana Final: <strong>${distributionInfo.weeklyAmountEstimate}</strong></div>
              <div className="mt-2">
                <em>Dependiendo de los segundos del día de inicio o finalización, calcula su monto 
                o si es ese mismo día o el siguiente o el anterior, dependiendo de la hora.</em>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cerrar
        </Button>
        <Button variant="primary" onClick={() => window.print()}>
          <FontAwesomeIcon icon="print" className="me-1" />
          Imprimir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default BudgetCalculationModal; 